<template>
    <v-btn :color="color" :class="css" :to="to">
        <v-icon left>{{ icon }}</v-icon>
        {{ buttonText }}
    </v-btn>
</template>

<script>
export default {
    props: {
        to: {
            required: true,
        },
        color: {
            default: 'indigo',
        },
        css: {
            default: 'white--text',
        },
        icon: {
            default: 'mdi-plus',
        },
        text: {
            default: 'Adicionar',
        },
        resource: {
            default: undefined,
        },
    },

    computed: {
        buttonText() {
            if (this.resource) {
                return `${this.text} ${this.resource}`
            }

            return this.text
        },
    },
}
</script>

<style></style>
